import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import AvailableToolTile from './AvailableToolTile';
import { LAUNCHER } from './launcherVisualTokens';

/**
 * Compact grid: column count follows item count (max 4) so width hugs icons
 * instead of stretching to a fixed panel width.
 */
const ToolGrid = ({ apps, onOpen, canAddMore, onAdd }) => {
  const colCount = useMemo(
    () => Math.min(4, Math.max(apps.length, 1)),
    [apps.length],
  );

  const tw = LAUNCHER.appTileWidth;

  return (
    <Box
      display="grid"
      w="max-content"
      maxW="100%"
      gridTemplateColumns={`repeat(${colCount}, ${tw})`}
      columnGap={2}
      rowGap={2}
    >
      {apps.map((app) => (
        <AvailableToolTile
          key={app.id}
          app={app}
          onOpen={onOpen}
          canAdd={canAddMore}
          onAdd={onAdd}
        />
      ))}
    </Box>
  );
};

export default ToolGrid;
